// 3D Model constants for SOT packages (SOT-23, SOT-223, SOT-89)
export const sotPinMarkerSize = 0.00025; // Small marker for SOT packages
export const sotPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 550;
export const sotPinMarkerOffsetZ = 0.000001;
export const sotPinMarkerSegments = 24;
//# sourceMappingURL=sotConstants.js.map